/**
 * How long a poll or sticky message has been live, or since it was taken
 * down: seconds under an hour, so a moderator can time it against the
 * broadcast, and hours and minutes after that.
 */
export const formatElapsed = (ms: number) => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1_000));
  const hours = Math.floor(totalSeconds / 3_600);
  const minutes = Math.floor((totalSeconds % 3_600) / 60);
  const seconds = totalSeconds % 60;
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  }
  return `${seconds}s`;
};
